import * as React from "react";
import { hot } from "react-hot-loader";
declare var libelle: any;


class ModalObligatoryMention extends React.Component<{}, {}> {
  public render() {
    return (
        <div className="modal fade" id="modalObligatoryMention" tabIndex={-1} role="dialog" aria-labelledby="modalObligatoryMentionLabel" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="modalObligatoryMentionLabel">{libelle.footer.modalTitle}</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body" dangerouslySetInnerHTML={{ __html: libelle.footer.modalBody }}/>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">{libelle.footer.modalClose}</button>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export default hot(module)(ModalObligatoryMention);
